import React from 'react';
import { Popover, Stack, Whisper } from 'rsuite';
import { FaExclamationTriangle } from 'react-icons/fa';
import { PricingAlertPriority, PricingDataListItem } from '../../api/apiTypes';

const alertColors: Record<PricingAlertPriority, string> = {
  [PricingAlertPriority.CRITICAL]: 'red',
  [PricingAlertPriority.MAJOR]: '#e6b800',
  [PricingAlertPriority.MINOR]: '#2196f3',
};

const alertOrder: PricingAlertPriority[] = [
  PricingAlertPriority.CRITICAL,
  PricingAlertPriority.MAJOR,
  PricingAlertPriority.MINOR,
];

interface Props {
  item: PricingDataListItem;
}

interface AlertIconProps {
  priority: PricingAlertPriority;
  messages: string[];
}

function AlertIcon({ priority, messages }: Readonly<AlertIconProps>) {
  const speaker = (
    <Popover className="error-message-tooltip" arrow={false} style={{ maxWidth: '400px' }}>
      <div>
        {messages.map(msg => (
          <p key={msg}>{msg}</p>
        ))}
      </div>
    </Popover>
  );

  return (
    <Whisper trigger="hover" placement="autoVerticalStart" preventOverflow speaker={speaker}>
      <span>
        <FaExclamationTriangle color={alertColors[priority]} cursor="pointer" />
      </span>
    </Whisper>
  );
}

export default function PricingAlertCell({ item }: Readonly<Props>) {
  const { alertsByPriority } = item;
  if (!alertsByPriority) {
    return null;
  }

  return (
    <Stack spacing={4}>
      {alertOrder.map(priority => {
        const messages = alertsByPriority[priority];
        if (!messages || messages.length === 0) {
          return null;
        }

        return <AlertIcon key={priority} priority={priority} messages={messages} />;
      })}
    </Stack>
  );
}
